// onload of document trigger function
$(document).ready(function () {
  $("#bar-zipcode").hide();
  if (zipcode == "") {
    console.log("no zipcode");
  } else {
    console.log("fast geo zip " + zipcode);
    $("#enterzipcode").val(zipcode);
    $(".zip_button").trigger("click");
  }
});
